import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

/* ✅ Dynamic API base URL — works locally & on HTTPS domain */
const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.quote.softvolute.in";
const getAuthConfig = () => {
  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("userToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: 30000,
  };
};
const Homepage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  /* ---------- Fetch projects ---------- */
  useEffect(() => {
    // 1️⃣ Instantly show cached data (for faster load)
    const cached = localStorage.getItem("projects");
    if (cached) {
      setProjects(JSON.parse(cached));
      setLoading(false);
    }

    // 2️⃣ Fetch fresh data in background
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/projects`, {
        timeout: 10000,
      });
      const data = res.data || [];
      setProjects(data);
      localStorage.setItem("projects", JSON.stringify(data)); // cache it
    } catch (err) {
      console.error("❌ Error loading projects:", err.message);
    } finally {
      setLoading(false);
    }
  };

  /* ---------- Categorization ---------- */
  const beforeBooking = projects.filter((p) => {
    const totalPaid = Number(p.totalPaid || 0);
    const finalAmount = Number(p.finalAmount || 0);
    const hasPayment = !!p.hasPayment || totalPaid > 0;

    return (!hasPayment || finalAmount === 0) && !p.isArchived;
  });

  const afterBooking = projects.filter((p) => {
    const totalPaid = Number(p.totalPaid || 0);
    const finalAmount = Number(p.finalAmount || 0);
    const hasPayment = !!p.hasPayment || totalPaid > 0;
    const isClosed = p.isClosed === true;

    return hasPayment && finalAmount > 0 && !isClosed;
  });
  /* ---------- UI ---------- */
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>📊 Project Overview</h2>

      {loading && projects.length === 0 ? (
        <p style={styles.loading}>⏳ Loading projects...</p>
      ) : (
        <div style={styles.cardContainer}>
          {/* Before Booking Card */}
          <div
            style={{ ...styles.card, borderTop: "5px solid #5F259F" }}
            onClick={() => navigate("/before-booking")}
          >
            <h3 style={{ ...styles.cardTitle, color: "#5F259F" }}>
              🕒 Before Booking
            </h3>
            <p style={styles.cardCount}>{beforeBooking.length} project(s)</p>
          </div>

          {/* After Booking Card */}
          <div
            style={{ ...styles.card, borderTop: "5px solid #28a745" }}
            onClick={() => navigate("/after-booking")}
          >
            <h3 style={{ ...styles.cardTitle, color: "#28a745" }}>
              💰 After Booking
            </h3>
            <p style={styles.cardCount}>{afterBooking.length} project(s)</p>
          </div>
        </div>
      )}
    </div>
  );
};

/* ---------- Styles ---------- */
const styles = {
  container: {
    padding: "40px 20px",
    background: "linear-gradient(to right, #fdfbfb, #ebedee)",
    minHeight: "100vh",
  },
  heading: {
    textAlign: "center",
    fontSize: "32px",
    marginBottom: "40px",
    color: "#343a40",
    fontWeight: "bold",
  },
  cardContainer: {
    display: "flex",
    gap: "40px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  card: {
    width: "300px",
    padding: "30px",
    borderRadius: "15px",
    background: "#ffffff",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    cursor: "pointer",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
  },
  cardTitle: {
    fontSize: "22px",
    marginBottom: "10px",
    fontWeight: "600",
  },
  cardCount: {
    fontSize: "18px",
    color: "#555",
  },
  loading: {
    textAlign: "center",
    color: "#555",
    fontSize: "20px",
    fontWeight: "500",
    marginTop: "100px",
  },
};

export default Homepage;
